export default __webpack_public_path__ + "static/media/targetEdit.e3839d57.svg";